import type { FilterConfig } from '../core/entities';
import type { SimEvent } from '../core/events';
import { isMaterial } from '../core/packet';
import type { PacketMaterial } from '../core/packet';
import {
  peekPort,
  portHasRoom,
  singleInput,
  singleOutput,
  tryPushToPort,
  tryTakeFromPort,
} from '../core/port';
import { drainOutput } from './shared';
import type { MachineHandler } from './registry';

/**
 * A tuple is not any of the materials a predicate tests for, so a join's output fails every filter
 * and is dropped — filter the streams going into a join, not the pairs coming out of it.
 */
function passes(config: FilterConfig, material: PacketMaterial): boolean {
  return isMaterial(material) && config.allow.includes(material);
}

export const filterHandler: MachineHandler = {
  kind: 'filter',
  step({ state, machine }) {
    if (machine.kind !== 'filter') return [];
    const events: SimEvent[] = [];
    const inputPort = singleInput(machine.inputs);
    const outputPort = singleOutput(machine.outputs);

    drainOutput(state, machine, events);

    const waitingId = peekPort(inputPort);
    if (waitingId !== undefined) {
      const packet = state.packets[waitingId];
      if (!packet) {
        tryTakeFromPort(inputPort);
      } else if (machine.config && passes(machine.config, packet.material)) {
        if (portHasRoom(outputPort)) {
          tryTakeFromPort(inputPort);
          tryPushToPort(outputPort, waitingId);
        }
      } else if (machine.config) {
        tryTakeFromPort(inputPort);
        delete state.packets[waitingId];
        events.push({ type: 'packetDespawned', packetId: waitingId });
      }
    }

    return events;
  },
};
